import { render, staticRenderFns } from "./SendMask.vue?vue&type=template&id=27518703&scoped=true&"
import script from "./SendMask.vue?vue&type=script&lang=js&"
export * from "./SendMask.vue?vue&type=script&lang=js&"
import style0 from "./SendMask.vue?vue&type=style&index=0&id=27518703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27518703",
  null
  
)

export default component.exports